import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private _onSaveWord$: Subject<void> = new Subject<void>();

  constructor() { }

  saveWord() {
    this._onSaveWord$.next();
  }

  onSaveWord() {
    return this._onSaveWord$.asObservable();
  }

  //#region Editor clear

  private _onEditorClearClick$: Subject<void> = new Subject();

  triggerOnEditorClearClick() {
    this._onEditorClearClick$.next();
  }

  onEditorClearClick() {
    return this._onEditorClearClick$.asObservable();
  }

  //#endregion

  //#region Previous
  private _prevFjala$: BehaviorSubject<number | null> = new BehaviorSubject<number | null>(null);
  private _onPrevClick$: Subject<void> = new Subject<void>();

  getPrevFjala() {
    return this._prevFjala$.asObservable();
  }

  setPrevFjala(id: number | null) {
    this._prevFjala$.next(id);
  }

  triggerPrevClick() {
    this._onPrevClick$.next();
  }

  onPrevClick() {
    return this._onPrevClick$.asObservable();
  }
  //#endregion

  //#region Enter
  
  private _onEnterClick$: Subject<void> = new Subject<void>();
  
  onEnterClick() {
    return this._onEnterClick$.asObservable();
  }

  triggerEnterClick() {
    this._onEnterClick$.next();
  }

  //#endregion

  //#region Next
  private _nextFjala$: BehaviorSubject<number | null> = new BehaviorSubject<number | null>(null);
  private _onNextClick$: Subject<void> = new Subject<void>();

  getNextFjala() {
    return this._nextFjala$.asObservable();
  }

  setNextFjala(id: number | null) {
    this._nextFjala$.next(id);
  }

  triggerNextClick() {
    this._onNextClick$.next();
  }

  onNextClick() {
    return this._onNextClick$.asObservable();
  }
  //#endregion

  //#region SaveBack
  private _saveBackFjala$: BehaviorSubject<number | null> = new BehaviorSubject<number | null>(null);
  private _onSaveBackClick$: Subject<void> = new Subject<void>();

  getSaveBackFjala() {
    return this._saveBackFjala$.asObservable();
  }

  setSaveBackFjala(id: number | null) {
    this._saveBackFjala$.next(id);
  }

  triggerSaveBackClick() {
    this._onSaveBackClick$.next();
  }

  onSaveBackClick() {
    return this._onSaveBackClick$.asObservable();
  }
  //#endregion

  //#region SaveNext
  private _saveNextFjala$: BehaviorSubject<number | null> = new BehaviorSubject<number | null>(null);
  private _onSaveNextClick$: Subject<void> = new Subject<void>();

  getSaveNextFjala() {
    return this._saveNextFjala$.asObservable();
  }

  setSaveNextFjala(id: number | null) {
    this._saveNextFjala$.next(id);
  }

  triggerSaveNextClick() {
    this._onSaveNextClick$.next();
  }

  onSaveNextClick() {
    return this._onSaveNextClick$.asObservable();
  }
  //#endregion

  //#region Delete

  private _onDeleteClick$: Subject<void> = new Subject<void>();

  triggerDeleteClick() {
    this._onDeleteClick$.next();
  }

  onDeleteClick() {
    return this._onDeleteClick$.asObservable();
  }

  //#endregion

  //#region Comments

  private _onCommentsClick$: Subject<void> = new Subject<void>();

  onCommentsClick() {
    return this._onCommentsClick$.asObservable();
  }

  triggerCommentsClick() {
    this._onCommentsClick$.next();
  }

  //#endregion

}
